import { Component, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Rubric, Skill, UserSkill } from '@mira-avant/mtlibs';
import { Subscription, BehaviorSubject } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormTitleComponent } from '../../../ui/forms/form-title/form-title.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { RubricLevelDropdownFieldComponent } from '../../../fields/standard/rubric-level-dropdown-field/rubric-level-dropdown-field.component';

@Component({
	selector: 'app-user-skill-level-form',
	standalone: true,
	imports: [
		CommonModule,
		NzTableModule,
		NzButtonModule,
		NzFormModule,
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		FormTitleComponent,
		RubricLevelDropdownFieldComponent,
	],
	templateUrl: './user-skill-level-form.component.html',
	styleUrl: './user-skill-level-form.component.scss',
})
export class UserSkillLevelFormComponent implements OnDestroy, OnChanges {
	@Input('rubric') public rubric: Rubric | undefined;
	@Input() skills: Skill[] = [];
	@Input() userSkills: UserSkill[] = [];
	@Input() selectedUserCognitoUuid?: string;
	@Output('onSubmit') onSubmitEmitter = new EventEmitter<{ [key: string]: number }>();

	public form: FormGroup;
	public loading$ = new BehaviorSubject<boolean>(false);
	private subscriptions: Subscription = new Subscription();

	constructor(private fb: FormBuilder) {
		// Initialize form
		this.form = this.fb.group({});
	}

	ngOnChanges(changes: SimpleChanges): void {
		// Update form controls when inputs change
		const formControls: { [key: string]: any } = {};

		this.skills.forEach(skill => {
			const userSkill = this.userSkills.find(
				us => us.skill_code === skill.code && us.rubric_code === this.rubric?.code
			);

			formControls[skill.code] = [userSkill ? userSkill.rubric_level_uuid : null];
		});

		this.form = this.fb.group(formControls);

		// Reset form if no user or rubric is selected
		if (!this.selectedUserCognitoUuid || !this.rubric?.code) {
			this.form.reset();
		}
	}

	public onSubmit(): void {
		if (this.form.invalid || !this.selectedUserCognitoUuid || !this.rubric?.code) {
			console.error('Form is invalid, no user selected, or no rubric provided', {
				formInvalid: this.form.invalid,
				user: this.selectedUserCognitoUuid,
				rubric: this.rubric?.code,
			});
			return;
		}

		// Emit form values to parent component
		this.onSubmitEmitter.emit(this.form.value);
	}

	public clear(): void {
		this.form.reset();
	}

	ngOnDestroy(): void {
		this.subscriptions.unsubscribe();
	}
}
